import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import UserCircleLinkViewModel from '@/Components/UserCircleLink/UserCircleLinkViewModel';
import LinkType from '@/Controls/Link';

export default class UserCircleLink extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');

    private jQueryControl: JQuery;
    private link: LinkType;

    public constructor(private viewModel: UserCircleLinkViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: any): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'userCircleLink',

            locator: this.viewModel.locator,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isActive()) {
                        states.push('active');
                    } else {
                        states.push('inactive');
                    }

                    if (this.viewModel.isEnabled()) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.link != null) {
            this.link = new this.Link(this.viewModel.link);
            let tuple = this.link.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('UserCircleLink', UserCircleLink, 'RADPresentation.HTMLClient.DefaultViewExtensions');